import { Redirect, Route, Switch } from 'react-router-dom';
import Loadable from 'react-loadable';
import React from 'react';

import Auth from 'utils/auth';
import SignIn from 'utils/signIn';

import Loading from 'components/base/Loading';
import EmployeeLayout from 'layouts/EmployeeLayout';
import HomeLayout from 'layouts/HomeLayout';
import ProjectLayout from 'layouts/ProjectLayout';

import Queries from 'graphql/Queries';

const Placeholder = () => <p>Placeholder...</p>;

const SignOut = () => {
  Auth.logout();
  return <Redirect to={{ pathname: '/sign-in' }} />;
};

const EmployeeEdit = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'EmployeeEdit' */ 'pages/EmployeeEdit'),
  loading: Loading,
});

const Employees = Loadable({
  loader: () => import(/* webpackChunkName: 'Employees' */ 'pages/Employees'),
  loading: Loading,
});

const Home = Loadable({
  loader: () => import(/* webpackChunkName: 'Home' */ 'pages/Home'),
  loading: Loading,
});

const MagicLinkRequest = Loadable({
  loader: () => import(/* webpackChunkName: 'SignIn' */ 'pages/SignIn'),
  loading: Loading,
});

const MagicLinkSent = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'MagicLinkSent' */ 'pages/MagicLinkSent'),
  loading: Loading,
});

const ProjectDashboard = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'ProjectDashboard' */ 'pages/project/Dashboard'),
  loading: Loading,
});

const ProjectDocuments = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'ProjectDocuments' */ 'pages/project/Documents'),
  loading: Loading,
});

const ProjectInvite = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'ProjectInvite' */ 'pages/project/Invite'),
  loading: Loading,
});

const ProjectSettings = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'ProjectSettings' */ 'pages/project/Settings'),
  loading: Loading,
});

const ProjectArchive = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'ProjectArchive' */ 'pages/project/Archive'),
  loading: Loading,
});

const ProjectUpdates = Loadable({
  loader: () => import(/* webpackChunkName: 'Updates' */ 'pages/project/updates/Updates'),
  loading: Loading,
});

const ProjectUpdate = Loadable({
  loader: () => import(/* webpackChunkName: 'UpdateView' */ 'pages/project/updates/Update'),
  loading: Loading,
});

const ProjectNewUpdate = Loadable({
  loader: () => import(/* webpackChunkName: 'UpdateNew' */ 'pages/project/updates/NewUpdate'),
  loading: Loading,
});

const ProjectEditUpdate = Loadable({
  loader: () => import(/* webpackChunkName: 'UpdateEdit' */ 'pages/project/updates/EditUpdate'),
  loading: Loading,
});

const ProjectDeleteUpdate = Loadable({
  loader: () => import(/* webpackChunkName: 'UpdateDelete' */ 'pages/project/updates/DeleteUpdate'),
  loading: Loading,
});

const ProjectBudget = Loadable({
  loader: () => import(/* webpackChunkName: 'Budget' */ 'pages/project/Budget'),
  loading: Loading,
});

const NotFound = Loadable({
  loader: () => import(/* webpackChunkName: 'NotFound' */ 'pages/NotFound'),
  loading: Loading,
});

const Routes = () => (
  <Switch>
    <Route exact path="/sign-in" component={MagicLinkRequest} />
    <Route path="/sign-in/:token" component={SignIn} />
    <Route path="/magic-link-sent" component={MagicLinkSent} />

    <Queries.CurrentUser loadingState="blank">
      {(user) => (
        <Switch>
          {(user && user.defaultProject) ?
              <Redirect exact from="/" to={`/project/${user.defaultProject}`} /> :
              <HomeLayout exact path="/" component={Home} />}

          <Route path="/sign-out" render={SignOut} />

          <HomeLayout exact path="/employees" component={Employees} permission="Employee" />
          <EmployeeLayout exact path="/employee/:id" component={EmployeeEdit} permission="Employee" />

          <ProjectLayout exact path="/project/:id" component={ProjectDashboard} />
          <ProjectLayout
            path="/project/:id/settings/archive"
            component={ProjectArchive}
            permission="Employee"
          />
          <ProjectLayout
            exact
            path="/project/:id/settings"
            component={ProjectSettings}
            permission="Employee"
          />
          <ProjectLayout
            path="/project/:id/invite"
            component={ProjectInvite}
            permission="Employee"
          />
          <ProjectLayout
            path="/project/:id/documents"
            component={ProjectDocuments}
          />
          <ProjectLayout exact path="/project/:id/updates" component={ProjectUpdates} />
          <ProjectLayout
            path="/project/:id/updates/new"
            component={ProjectNewUpdate}
            permission="Employee"
          />
          <ProjectLayout exact path="/project/:id/updates/:updateID" component={ProjectUpdate} />
          <ProjectLayout
            path="/project/:id/updates/:updateID/edit"
            component={ProjectEditUpdate}
            permission="Employee"
          />
          <ProjectLayout
            path="/project/:id/updates/:updateID/delete"
            component={ProjectDeleteUpdate}
            permission="Employee"
          />
          <ProjectLayout path="/project/:id/budget" component={ProjectBudget} />
          <ProjectLayout path="/project/:id/survey" component={Placeholder} />

          <Redirect from="/projects" to="/" />
        </Switch>
      )}
    </Queries.CurrentUser>

    <Route path="*" component={NotFound} />
  </Switch>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js